import { lazy } from 'react';
import Loadable from 'core/components/Loadable';

import { LAYOUT_MAIN } from '../core/constants';

import * as constants from 'store/entities/constants';

// Generales
const NotFound = Loadable(lazy(() => import('entorno/notfound')));
const ReportView = Loadable(lazy(() => import('reports')));
const FormView = Loadable(lazy(() => import('reports/components/Report')));

// Seguimiento
const Dashboard = Loadable(lazy(() => import('views/Dashboard/Default')));
const Tablero = Loadable(lazy(() => import('views/seguimiento/Tablero')));
const Validar = Loadable(lazy(() => import('views/seguimiento/Validar')));
const Tareas = Loadable(lazy(() => import('views/seguimiento/Tareas')));

// Maestros
const Clientes = Loadable(lazy(() => import('views/ventas/Clientes')));
const Proveedores = Loadable(lazy(() => import('views/compras/Proveedores')));
const Usuarios = Loadable(lazy(() => import('views/entorno/Usuarios')));

// Administración / Contabilidad
const PartidasPresupuesto = Loadable(
    lazy(() => import('views/contabilidad/Partidas'))
);
const PresupuestoContable = Loadable(
    lazy(() => import('views/contabilidad/Presupuestos'))
);
const Subcuentas = Loadable(
    lazy(() => import('views/contabilidad/Subcuentas'))
);
const Gastos = Loadable(lazy(() => import('views/contabilidad/Gastos')));
const Facturas = Loadable(lazy(() => import('views/ventas/Facturas')));
const Diario = Loadable(lazy(() => import('views/contabilidad/Diario')));

// Administración / Tesorería
const FormasPago = Loadable(lazy(() => import('views/tesoreria/formas-pago')));
const Bancos = Loadable(lazy(() => import('views/tesoreria/bancos')));
const Vencimientos = Loadable(
    lazy(() => import('views/tesoreria/vencimientos'))
);
const MovimientosTesoreria = Loadable(
    lazy(() => import('views/tesoreria/movimientos'))
);

// Administración / Impuestos
const Mod347 = Loadable(
    lazy(() => import('views/contabilidad/declaraciones/M347'))
);

const Expediciones = Loadable(lazy(() => import('views/expediciones')));

export const privateRoutes = layouts => [
    {
        path: '/Report/:Report',
        element: <ReportView />
    },
    {
        path: '/form/:form',
        element: <FormView />
    },
    {
        path: '/',
        element: layouts[LAYOUT_MAIN],
        children: [
            {
                path: '/',
                element: <Dashboard />
            },
            {
                path: '/seguimiento/dashboard',
                element: <Dashboard />
            },
            {
                path: '/seguimiento/tablero',
                element: <Tablero />
            },
            {
                path: '/seguimiento/validar',
                element: <Validar />
            },
            {
                path: '/gestion/maestros/clientes',
                element: <Clientes />
            },
            {
                path: '/gestion/maestros/proveedores',
                element: <Proveedores />
            },
            {
                path: '/administracion/contabilidad/gastos',
                element: <Gastos />
            },
            {
                path: '/gestion/facturacion/facturas',
                element: <Facturas />
            },
            {
                path: '/administracion/tesoreria/formaspago',
                element: <FormasPago />
            },
            {
                path: '/administracion/tesoreria/bancos',
                element: <Bancos />
            },
            {
                path: '/gestion/maestros/usuarios',
                element: <Usuarios />
            },
            {
                path: '/seguimiento/tareas',
                element: <Tareas />
            },

            {
                path: '/administracion/contabilidad/cuentas',
                element: <Subcuentas />
            },
            {
                path: '/administracion/contabilidad/partidas',
                element: <PartidasPresupuesto />
            },
            {
                path: '/administracion/contabilidad/presupuestos',
                element: <PresupuestoContable />
            },
            {
                path: '/administracion/contabilidad/diario',
                element: <Diario />
            },
            {
                path: '/administracion/tesoreria/vencimientos',
                element: <Vencimientos />
            },
            {
                path: '/administracion/tesoreria/movimientos',
                element: <MovimientosTesoreria />
            },
            {
                path: '/administracion/contabilidad/declaraciones/m347proveedores',
                element: <Mod347 tipo={constants.IMPUESTO_347_PROVEEDORES} />
            },
            {
                path: '/administracion/contabilidad/declaraciones/m347clientes',
                element: <Mod347 tipo={constants.IMPUESTO_347_CLIENTES} />
            }
        ]
    },
    { path: '*', element: <NotFound /> }
];
